class Partners extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 8,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
                1024: {
                    sliderPerView: 5,
                    spaceBetween: 50
                },
                1440: {
                    sliderPerView: 6,
                    spaceBetween: 60
                },
                1600: {
                    sliderPerView: 7,
                    spaceBetween: 70
                },
                1920: {
                    sliderPerView: 8,
                    spaceBetween: 80
                }
            },
            watchOverflow: true,
            pagination: false,
            loop: true,
            speed: 400,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            }
        });
    }
}
